import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TooltipContent, TooltipService } from 'src/app/services/tooltip.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'vrm-tooltip',
  templateUrl: './vrm-tooltip.component.html',
  styleUrls: ['./vrm-tooltip.component.scss'],
})
export class VrmTooltipComponent implements OnInit, OnDestroy {
  isVisible = false;
  visibilitySubscription: Subscription;
  positionalSubscription: Subscription;
  contentSubscription: Subscription;
  content: TooltipContent = { title: '', description: '' };

  @ViewChild('element', { static: false }) element: ElementRef;

  /**
   * Creates a new instance of VrmTooltipComponent
   */
  constructor(
    private tooltipService: TooltipService,
    public cService: CommonService,
    private change: ChangeDetectorRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    // Subscribe to visibility changes
    this.visibilitySubscription = this.tooltipService.isVisible.subscribe((isVisible) => {
      this.isVisible = isVisible;
      this.change.detectChanges();
    });

    // Subscribe to positional changes
    this.positionalSubscription = this.tooltipService.position$.subscribe((newPosition) => {
      this.setPosition(newPosition);
    });

    // Subscribe to content changes
    this.contentSubscription = this.tooltipService.content$.subscribe((content) => {
      this.content = this.tooltipService.attemptTooltipContentTranslation(content);
    });
  }

  /**
   * Sets the position of the tooltip
   */
  setPosition(newPosition: { x: number; y: number }) {
    if (this.element) {
      if (this.cService.selectedLanguage && this.cService.selectedLanguage.isRtl) {
        const rightX = window.innerWidth - newPosition.x;
        this.renderer.setStyle(this.element.nativeElement, 'right', `${rightX}px`);
        this.renderer.setStyle(this.element.nativeElement, 'left', `auto`);
      } else {
        this.renderer.setStyle(this.element.nativeElement, 'left', `${newPosition.x}px`);
      }

      this.renderer.setStyle(this.element.nativeElement, 'top', `${newPosition.y}px`);

      if (this.isCuttingOffBottom(this.element.nativeElement)) {
        this.renderer.addClass(this.element.nativeElement, 'tooltip-from-bottom');
      } else {
        this.renderer.removeClass(this.element.nativeElement, 'tooltip-from-bottom');
      }
    }
  }

  /**
   * Returns true if the bottom of the tooltip is out of the viewport.
   */
  private isCuttingOffBottom(element: HTMLElement): boolean {
    const bounds = element.getBoundingClientRect();
    return bounds.bottom > (window.innerHeight || document.documentElement.clientHeight);
  }

  ngOnDestroy(): void {
    if (this.visibilitySubscription) {
      this.visibilitySubscription.unsubscribe();
    }

    if (this.positionalSubscription) {
      this.positionalSubscription.unsubscribe();
    }

    if (this.contentSubscription) {
      this.contentSubscription.unsubscribe();
    }
  }
}
